(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  (function () {
    const FORM_NAME = 'footer_contact';

    const track = (name, params) => window.caTrack?.(name, params);
    const trackError = (type) => track('form_error', { form_name: FORM_NAME, error_type: type });

    function init(root) {
      root.querySelectorAll('[data-contact-form]').forEach((form) => {
        if (form.dataset.ready) return;
        form.dataset.ready = 'true';

        // Localised messages are rendered by Liquid into data attributes
        const { msgOk: MSG_OK, msgErr: MSG_ERR, msgCap: MSG_CAP, msgRate: MSG_RATE } = form.dataset;
        const status = form.querySelector('[data-contact-status]');
        const btn    = form.querySelector('button[type="submit"]');
        const widget = form.querySelector('.cf-turnstile');

        const show = (msg, type) => {
          status.textContent = msg;
          status.dataset.type = type;
          status.hidden = false;
        };

        form.addEventListener('focusin', () => {
          track('form_start', { form_name: FORM_NAME });
        }, { once: true });

        form.addEventListener('submit', async (e) => {
          e.preventDefault();
          if (!form.reportValidity()) { trackError('validation'); return; }

          const fd = new FormData(form);
          const token = fd.get('cf-turnstile-response');
          if (!token) { show(MSG_CAP, 'error'); trackError('no_token'); return; }

          btn.disabled = true;
          btn.setAttribute('aria-busy', 'true');

          try {
            const res = await fetch(form.action, {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({
                firstName: fd.get('firstName'),
                lastName:  fd.get('lastName'),
                email:     fd.get('email'),
                message:   fd.get('message'),
                website:   fd.get('website'),
                locale:    form.dataset.locale || document.documentElement.lang || 'en',
                token,
              }),
            });
            const out = await res.json().catch(() => ({}));

            if (res.ok && out.ok) {
              form.reset();
              show(MSG_OK, 'success');
              track('generate_lead', {
                form_name: FORM_NAME,
                lead_source: 'website'
              });
            } else if (out.error === 'captcha') {
              show(MSG_CAP, 'error');
              trackError('captcha');
            } else if (out.error === 'rate') {
              show(MSG_RATE, 'error');
              trackError('rate');
            } else {
              show(MSG_ERR, 'error');
              trackError('server_' + res.status);
            }
          } catch {
            show(MSG_ERR, 'error');
            trackError('network');
          } finally {
            btn.disabled = false;
            btn.removeAttribute('aria-busy');
            if (window.turnstile && widget) window.turnstile.reset(widget);
          }
        });
      });
    }

    document.addEventListener('click', (e) => {
      const link = e.target.closest('[data-cookie-prefs]');
      if (!link || !window.privacyBanner) return;
      e.preventDefault();
      window.privacyBanner.showPreferences();
    });

    function loadMap(box) {
      if (box.dataset.loaded) return;
      const f = document.createElement('iframe');
      f.src = box.dataset.src;
      f.title = box.dataset.title || 'Map';
      f.loading = 'lazy';
      f.referrerPolicy = 'no-referrer-when-downgrade';
      f.allowFullscreen = true;
      box.appendChild(f);
      box.dataset.loaded = 'true';
      box.querySelector('[data-map-load]')?.remove();
    }

    function initMaps(root) {
      const boxes = root.querySelectorAll('[data-map]');
      if (!boxes.length) return;

      boxes.forEach((box) => {
        box.querySelector('[data-map-load]')?.addEventListener('click', () => loadMap(box));
      });

      const checkConsent = () => {
        const cp = window.Shopify && window.Shopify.customerPrivacy;
        if (!cp || !cp.preferencesProcessingAllowed()) return;
        if (!('IntersectionObserver' in window)) { boxes.forEach(loadMap); return; }
        const io = new IntersectionObserver((entries) => {
          entries.forEach((en) => {
            if (!en.isIntersecting) return;
            io.unobserve(en.target);
            loadMap(en.target);
          });
        }, { rootMargin: '200px 0px' });
        boxes.forEach((box) => io.observe(box));
      };

      if (window.Shopify && window.Shopify.loadFeatures) {
        window.Shopify.loadFeatures(
          [{ name: 'consent-tracking-api', version: '0.1' }],
          (err) => { if (!err) checkConsent(); }
        );
      }
      document.addEventListener('visitorConsentCollected', checkConsent);
    }

    function loadTurnstile() {
      if (document.getElementById('cf-turnstile-js')) return;
      const s = document.createElement('script');
      s.id = 'cf-turnstile-js';
      s.src = 'https://challenges.cloudflare.com/turnstile/v0/api.js';
      s.async = true;
      document.head.appendChild(s);
    }
    const tsForm = document.querySelector('[data-contact-form]');
    if (tsForm) {
      if ('IntersectionObserver' in window) {
        const io = new IntersectionObserver((entries) => {
          if (entries.some((en) => en.isIntersecting)) {
            loadTurnstile();
            io.disconnect();
          }
        }, { rootMargin: '600px 0px' });
        io.observe(tsForm);
      } else {
        loadTurnstile();
      }
    }

    initMaps(document);

    init(document);
    document.addEventListener('shopify:section:load', (e) => { init(e.target); initMaps(e.target); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gallery-slider"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function init(root) {
      if (root.dataset.init) return;
      root.dataset.init = '1';

      var track = root.querySelector('.gallery-slider__track');
      var slides = Array.prototype.slice.call(track.children);
      var link = root.querySelector('.gallery-slider__link');
      var moved = false;

      function slideIndex() { return (index % total) + 1; }

      link.addEventListener('click', function (e) {
        if (moved) { e.preventDefault(); moved = false; return; }
        if (window.caTrack) caTrack('gallery_click', {
          label: link.dataset.trackLabel,
          slide_index: slides.length > 1 ? slideIndex() : 1
        });
      });

      if (slides.length <= 1) return;

      var interval = (parseInt(root.dataset.interval, 10) || 3) * 1000;
      var total = slides.length;
      var index = 0, animating = false;

      // clone first slide for a seamless forward loop
      track.appendChild(slides[0].cloneNode(true));

      function go(i, animate) {
        track.style.transition = animate ? '' : 'none';
        track.style.transform = 'translateX(' + (-i * 100) + '%)';
      }

      track.addEventListener('transitionend', function () {
        animating = false;
        if (index === total) {
          index = 0;
          go(0, false);
          void track.offsetWidth;
          track.style.transition = '';
        }
      });

      function next() {
        if (animating) return;
        animating = true; index++; go(index, true);
      }
      function prev() {
        if (animating) return;
        animating = true;
        if (index === 0) {
          index = total; go(total, false); void track.offsetWidth;
          index = total - 1; go(index, true);
        } else {
          index--; go(index, true);
        }
      }

      var timer = null;
      function play() { stop(); timer = setInterval(next, interval); }
      function stop() { if (timer) { clearInterval(timer); timer = null; } }

      if (window.matchMedia('(hover: hover) and (pointer: fine)').matches) {
        root.addEventListener('mouseenter', stop);
        root.addEventListener('mouseleave', play);
      }
      document.addEventListener('visibilitychange', function () {
        if (document.hidden) stop(); else play();
      });

      // Touch: swipe back only
      if (window.matchMedia('(pointer: coarse)').matches) {
        var startX = 0, dragging = false;
        root.addEventListener('touchstart', function (e) {
          startX = e.touches[0].clientX; dragging = true; moved = false; stop();
        }, { passive: true });
        root.addEventListener('touchmove', function (e) {
          if (dragging && Math.abs(e.touches[0].clientX - startX) > 10) moved = true;
        }, { passive: true });
        root.addEventListener('touchend', function (e) {
          if (!dragging) return; dragging = false;
          var dx = e.changedTouches[0].clientX - startX;
          if (dx > 40) {
            prev();
            if (window.caTrack) caTrack('slider_nav', {
              slider_name: 'gallery_slider',
              method: 'swipe',
              slide_index: slideIndex()
            });
          }
          play();
        });
      }

      if ('IntersectionObserver' in window) {
        var io = new IntersectionObserver(function (entries) {
          entries.forEach(function (en) {
            if (en.isIntersecting) {
              root.querySelectorAll('img').forEach(function (img) { img.loading = 'eager'; });
              io.disconnect();
            }
          });
        });
        io.observe(root);
      }

      go(0, false);
      play();
    }

    document.querySelectorAll('.gallery-slider').forEach(init);
    document.addEventListener('shopify:section:load', function (e) {
      e.target.querySelectorAll('.gallery-slider').forEach(init);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  (function () {
    const toggle = document.querySelector('[data-drawer-toggle]');
    const drawer = document.querySelector('[data-drawer]');
    if (!toggle || !drawer) return;

    const isOpen = () => drawer.classList.contains('is-open');

    function open() {
      drawer.classList.add('is-open');
      drawer.removeAttribute('inert');
      toggle.setAttribute('aria-expanded', 'true');
      document.body.classList.add('drawer-open');
    }
    function close() {
      drawer.classList.remove('is-open');
      drawer.setAttribute('inert', '');
      toggle.setAttribute('aria-expanded', 'false');
      document.body.classList.remove('drawer-open');
    }

    // Single control: the burger opens and closes the drawer
    toggle.addEventListener('click', () => (isOpen() ? close() : open()));

    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && isOpen()) {
        close();
        toggle.focus();
      }
    });

    drawer.querySelectorAll('.menu-drawer__link').forEach((a) => {
      const label = (a.dataset.label || a.textContent).trim().toLowerCase();
      const footer = document.getElementById('contact');

      if ((label === 'contacts' || label === 'contactos') && footer) {
        a.addEventListener('click', (e) => {
          if (footer.offsetParent === null) {
            close();
            return;
          }
          e.preventDefault();
          close();
          footer.scrollIntoView({ behavior: 'smooth', block: 'start' });
        });
      } else {
        a.addEventListener('click', close);
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero-slider-text"] && !Shopify.designMode) return;
  try {
    
  class HeroSlider extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('.hslider__track');
      this.slides = Array.from(this.querySelectorAll('.hslider__slide'));
      this.index = 0;
      this.loop = this.dataset.loop === 'true';
      this._ready = false;

      if (this.slides.length <= 1) return;

      this.prevBtn = this.querySelector('.hslider__arrow--prev');
      this.nextBtn = this.querySelector('.hslider__arrow--next');

      this.prevBtn?.addEventListener('click', () => { this.go(-1); this._track('arrow_prev'); });
      this.nextBtn?.addEventListener('click', () => { this.go(1); this._track('arrow_next'); });

      this.dots = Array.from(this.querySelectorAll('.hslider__dot'));
      this.dots.forEach((dot, i) =>
        dot.addEventListener('click', () => { this.goTo(i); this._track('dot'); })
      );
      this._bindDrag();
      this.update();

      // Load neighbouring slides only after the page has loaded (keeps them out of the LCP window)
      const ready = () => { this._ready = true; this._hydrateAround(); };
      if (document.readyState === 'complete') ready();
      else window.addEventListener('load', ready, { once: true });

      // Autoplay
      this.autoplay = this.dataset.autoplay === 'true'
        && !window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      this.interval = (parseInt(this.dataset.interval, 10) || 5) * 1000;

      if (this.autoplay) {
        this.addEventListener('mouseenter', () => this.stop());
        this.addEventListener('mouseleave', () => this.play());
        this.addEventListener('focusin', () => this.stop());
        this.addEventListener('focusout', () => this.play());
        this._onVis = () => (document.hidden ? this.stop() : this.play());
        document.addEventListener('visibilitychange', this._onVis);
        this.play();
      }
    }

    disconnectedCallback() {
      this.stop();
      if (this._onVis) document.removeEventListener('visibilitychange', this._onVis);
    }

    _hydrate(i) {
      const slide = this.slides[i];
      if (!slide) return;
      const img = slide.querySelector('img[data-src]');
      if (!img) return;
      if (img.dataset.srcset) img.srcset = img.dataset.srcset;
      img.src = img.dataset.src;
      img.removeAttribute('data-src');
      img.removeAttribute('data-srcset');
    }

    _hydrateAround() {
      const n = this.slides.length;
      this._hydrate(this.index);
      if (this.loop || this.index < n - 1) this._hydrate((this.index + 1) % n);
      if (this.loop || this.index > 0) this._hydrate((this.index - 1 + n) % n);
    }

    play() {
      if (!this.autoplay || !this.isConnected) return;
      this.stop();
      this._timer = setInterval(() => this.next(), this.interval);
    }

    stop() {
      clearInterval(this._timer);
      this._timer = null;
    }

    next() {
      this.index = (this.index + 1) % this.slides.length;
      this.track.style.transition = '';
      this.update();
    }

    _bindDrag() {
      this.drag = { active: false, startX: 0, startY: 0, dx: 0, w: 0, axis: null };

      this.addEventListener('pointerdown', (e) => this._onDown(e));
      this.addEventListener('pointermove', (e) => this._onMove(e));
      this.addEventListener('pointerup', () => this._onUp());
      this.addEventListener('pointercancel', () => this._onUp());
    }

    // touch/pen always; mouse only on small viewports (keeps desktop clicks clean)
    _draggable(e) {
      return e.pointerType !== 'mouse' || window.matchMedia('(max-width: 1024px)').matches;
    }

    _onDown(e) {
      if (!this._draggable(e)) return;
      if (e.target.closest('.hslider__arrow')) return;
      if (e.target.closest('.hslider__dot')) return;

      const d = this.drag;
      d.active = true;
      d.axis = null;
      d.startX = e.clientX;
      d.startY = e.clientY;
      d.dx = 0;
      d.w = this.track.getBoundingClientRect().width;
      this.track.style.transition = 'none';
      this._hydrateAround(); // user is interacting: make sure neighbours are loaded
    }

    _onMove(e) {
      const d = this.drag;
      if (!d.active) return;

      const dx = e.clientX - d.startX;
      const dy = e.clientY - d.startY;

      // lock axis after a small movement
      if (d.axis === null) {
        if (Math.abs(dx) < 8 && Math.abs(dy) < 8) return;
        d.axis = Math.abs(dx) > Math.abs(dy) ? 'x' : 'y';
        if (d.axis === 'x') this.setPointerCapture(e.pointerId);
      }

      // vertical movement = page scroll, release the drag
      if (d.axis === 'y') {
        d.active = false;
        this._snapBack();
        return;
      }

      e.preventDefault();
      d.dx = dx;
      const base = -this.index * d.w;
      this.track.style.transform = `translateX(${base + dx}px)`;
    }

    _onUp() {
      const d = this.drag;
      if (!d.active) return;
      d.active = false;

      if (d.axis !== 'x') { this._snapBack(); return; }

      const threshold = d.w * 0.15;
      if (d.dx <= -threshold) { this.go(1); this._track('swipe'); }
      else if (d.dx >= threshold) { this.go(-1); this._track('swipe'); }
      else this._snapBack();
    }

    _snapBack() {
      this.track.style.transition = '';
      this.update();
    }

    go(dir) {
      const n = this.slides.length;
      let i = this.index + dir;

      if (this.loop) {
        i = (i + n) % n;
      } else {
        i = Math.max(0, Math.min(n - 1, i));
      }

      this.index = i;
      this.track.style.transition = '';
      this.update();
      if (this._timer) this.play(); // restart countdown after manual navigation
    }

    goTo(i) {
      const n = this.slides.length;
      this.index = Math.max(0, Math.min(n - 1, i));
      this._hydrate(this.index); // dots can jump to any slide
      this.track.style.transition = '';
      this.update();
      if (this._timer) this.play();
    }

    _track(method) {
      window.caTrack?.('slider_nav', {
        slider_name: this.dataset.sliderName,
        method,
        slide_index: this.index + 1
      });
    }

    update() {
      this.track.style.transform = `translateX(-${this.index * 100}%)`;
      if (this._ready) this._hydrateAround();

      if (!this.loop) {
        if (this.prevBtn) this.prevBtn.disabled = this.index === 0;
        if (this.nextBtn) this.nextBtn.disabled = this.index === this.slides.length - 1;
      }

      if (this.dots) {
        this.dots.forEach((dot, i) =>
          dot.setAttribute('aria-selected', i === this.index ? 'true' : 'false')
        );
      }
    }
  }

  if (!customElements.get('hero-slider')) {
    customElements.define('hero-slider', HeroSlider);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["legal-doc"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var root = document.querySelector('[data-legal]');
    if (!root) return;

    var links = root.querySelectorAll('.legal__index-link');
    if (!links.length) return;

    var map = {};
    links.forEach(function (l) { map[l.dataset.target] = l; });

    // Scrollspy — highlight current clause in the index
    if ('IntersectionObserver' in window) {
      var obs = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          var link = map[e.target.id];
          if (!link) return;
          if (e.isIntersecting) {
            links.forEach(function (l) { l.classList.remove('is-active'); });
            link.classList.add('is-active');
          }
        });
      }, { rootMargin: '-30% 0px -60% 0px', threshold: 0 });

      root.querySelectorAll('.legal__clause').forEach(function (c) { obs.observe(c); });
    }

    // On mobile, close the index after picking a clause
    var details = root.querySelector('[data-index]');
    if (details) {
      links.forEach(function (l) {
        l.addEventListener('click', function () {
          if (window.matchMedia('(max-width: 900px)').matches) details.open = false;
        });
      });
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["recipe-page"]) return;
  try {
    
  (function () {
    const track = (name, params) => window.caTrack?.(name, params);

    const page   = document.querySelector('[data-recipe]');
    const recipe = page?.dataset.recipeName;

    if (page) {
      track('view_recipe', {
        recipe_name: recipe,
        recipe_category: page.dataset.recipeCategory,
        recipe_index: Number(page.dataset.recipeIndex)
      });
    }

    const openers = document.querySelectorAll('[data-soon-open]');
    const modal   = document.querySelector('[data-soon-modal]');
    if (!modal || !openers.length) return;
    const closers = modal.querySelectorAll('[data-soon-close]');

    function open() {
      modal.classList.add('is-open');
      modal.removeAttribute('inert');
      document.body.classList.add('drawer-open');
    }
    function close() {
      modal.classList.remove('is-open');
      modal.setAttribute('inert', '');
      document.body.classList.remove('drawer-open');
    }

    openers.forEach((b) => b.addEventListener('click', open));
    closers.forEach((b) => b.addEventListener('click', close));
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && modal.classList.contains('is-open')) close();
    });

    modal.querySelector('input[name="contact[email]"]')?.addEventListener('focusin', () => {
      track('form_start', { form_name: 'coming_soon_modal', recipe_name: recipe });
    }, { once: true });

    if (modal.querySelector('[data-soon-autoopen]')) open();

    if (modal.querySelector('[data-soon-success]')) {
      track('sign_up', {
        method: 'newsletter',
        form_name: 'coming_soon_modal',
        recipe_name: recipe
      });
      history.replaceState(null, '', location.pathname);
    } else if (modal.querySelector('.soon-modal__msg--error')) {
      track('form_error', { form_name: 'coming_soon_modal', error_type: 'email' });
      history.replaceState(null, '', location.pathname);
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["slider"] && !Shopify.designMode) return;
  try {
    
  class SliderComponent extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('.slider__track');
      this.slides = Array.from(this.querySelectorAll('.slider__slide'));
      this.index = 0;
      this.loop = this.dataset.loop === 'true';

      if (this.slides.length <= 1) return;

      this.prevBtn = this.querySelector('.slider__arrow--prev');
      this.nextBtn = this.querySelector('.slider__arrow--next');

      this.prevBtn?.addEventListener('click', () => this.go(-1));
      this.nextBtn?.addEventListener('click', () => this.go(1));

      this.update();
    }

    go(dir) {
      const n = this.slides.length;
      let i = this.index + dir;

      if (this.loop) {
        i = (i + n) % n;
      } else {
        i = Math.max(0, Math.min(n - 1, i));
      }

      this.index = i;
      this.update();
    }

    update() {
      this.track.style.transform = `translateX(-${this.index * 100}%)`;

      if (!this.loop) {
        if (this.prevBtn) this.prevBtn.disabled = this.index === 0;
        if (this.nextBtn) this.nextBtn.disabled = this.index === this.slides.length - 1;
      }
    }
  }

  if (!customElements.get('slider-component')) {
    customElements.define('slider-component', SliderComponent);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["split-hover-panels"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function hydrate(slide) {
      var img = slide && slide.querySelector('img[data-src]');
      if (!img) return;
      if (img.dataset.srcset) img.srcset = img.dataset.srcset;
      img.src = img.dataset.src;
      img.removeAttribute('data-src');
      img.removeAttribute('data-srcset');
    }

    function start(slider) {
      var slides = slider.querySelectorAll('.split-panel__slide');
      var interval = parseInt(slider.dataset.interval, 10) || 4000;
      var i = 0;
      hydrate(slides[1]); // preload the next one while the first is showing
      slider._timer = setInterval(function () {
        var next = (i + 1) % slides.length;
        hydrate(slides[next]);
        slides[i].classList.remove('is-active');
        slides[next].classList.add('is-active');
        i = next;
        hydrate(slides[(i + 1) % slides.length]);
      }, interval);
    }

    function initSliders(root) {
      root.querySelectorAll('.split-panel__slider[data-interval]').forEach(function (slider) {
        if (slider.dataset.sliderInit === 'true') return;
        var slides = slider.querySelectorAll('.split-panel__slide');
        if (slides.length < 2) return;
        slider.dataset.sliderInit = 'true';

        // Start rotating (and loading extra slides) only once the panel is near the viewport
        if (!('IntersectionObserver' in window)) { start(slider); return; }
        var io = new IntersectionObserver(function (entries) {
          if (!entries.some(function (en) { return en.isIntersecting; })) return;
          io.disconnect();
          start(slider);
        }, { rootMargin: '200px 0px' });
        io.observe(slider);
      });
    }

    initSliders(document);
    document.addEventListener('shopify:section:load', function (e) { initSliders(e.target); });
    document.addEventListener('shopify:section:unload', function (e) {
      e.target.querySelectorAll('.split-panel__slider').forEach(function (s) {
        if (s._timer) clearInterval(s._timer);
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tabs-content"] && !Shopify.designMode) return;
  try {
    
  class TabsContent extends HTMLElement {
    connectedCallback() {
      this.panels = Array.from(this.querySelectorAll('.tabs__panel'));
      this.tabs = Array.from(this.querySelectorAll('.tabs__tab'));
      this.dots = Array.from(this.querySelectorAll('.tabs__dot'));
      this.panelsEl = this.querySelector('.tabs__panels');

      this.index = 0;

      if (this.panels.length <= 1) return;

      this.tabs.forEach((tab) => {
        tab.addEventListener('click', () => this.setActive(Number(tab.dataset.index), 'tab'));
      });

      this.dots.forEach((dot) => {
        dot.addEventListener('click', () => this.setActive(Number(dot.dataset.index), 'dot'));
      });

      this.querySelector('.tabs__chevron--prev')?.addEventListener('click', () => this.go(-1, 'chevron_prev'));
      this.querySelector('.tabs__chevron--next')?.addEventListener('click', () => this.go(1, 'chevron_next'));

      const nav = this.querySelector('.tabs__nav');
      nav?.addEventListener('keydown', (e) => {
        if (e.key === 'ArrowRight') { e.preventDefault(); this.go(1, 'keyboard'); this.tabs[this.index].focus(); }
        if (e.key === 'ArrowLeft')  { e.preventDefault(); this.go(-1, 'keyboard'); this.tabs[this.index].focus(); }
      });

      this._bindSwipe();
    }

    _bindSwipe() {
      this.drag = { active: false, x: 0, y: 0, dx: 0, axis: null };
      const el = this.panelsEl;
      if (!el) return;

      el.addEventListener('pointerdown', (e) => this._down(e));
      el.addEventListener('pointermove', (e) => this._move(e));
      el.addEventListener('pointerup', () => this._up());
      el.addEventListener('pointercancel', () => this._up());
    }

    // touch/pen sempre; rato só em viewport pequeno (não interferir com desktop)
    _swipeable(e) {
      return e.pointerType !== 'mouse' || window.matchMedia('(max-width: 1024px)').matches;
    }

    _down(e) {
      if (!this._swipeable(e)) return;
      if (e.target.closest('.tabs__chevron') || e.target.closest('.tabs__dot')) return;

      const d = this.drag;
      d.active = true;
      d.axis = null;
      d.x = e.clientX;
      d.y = e.clientY;
      d.dx = 0;
    }

    _move(e) {
      const d = this.drag;
      if (!d.active) return;

      const dx = e.clientX - d.x;
      const dy = e.clientY - d.y;

      if (d.axis === null) {
        if (Math.abs(dx) < 8 && Math.abs(dy) < 8) return;
        d.axis = Math.abs(dx) > Math.abs(dy) ? 'x' : 'y';
      }

      if (d.axis === 'y') { d.active = false; return; }

      e.preventDefault();
      d.dx = dx;
    }

    _up() {
      const d = this.drag;
      if (!d.active) return;
      d.active = false;

      if (d.axis !== 'x') return;

      const threshold = 60;
      if (d.dx <= -threshold) this.go(1, 'swipe');
      else if (d.dx >= threshold) this.go(-1, 'swipe');
    }

    go(dir, method) {
      const n = this.panels.length;
      const i = (this.index + dir + n) % n;
      this.setActive(i, method);
    }

    setActive(i, method) {
      const prev = this.index;
      this.index = i;

      this.panels.forEach((panel, idx) => {
        const active = idx === i;
        panel.classList.toggle('is-active', active);
        panel.hidden = !active;
      });

      this.tabs.forEach((tab, idx) => {
        const active = idx === i;
        tab.classList.toggle('is-active', active);
        tab.setAttribute('aria-selected', active ? 'true' : 'false');
        tab.tabIndex = active ? 0 : -1;
      });

      this.dots.forEach((dot, idx) => {
        const active = idx === i;
        dot.classList.toggle('is-active', active);
        dot.setAttribute('aria-selected', active ? 'true' : 'false');
      });

      if (method && i !== prev) {
        window.caTrack?.('tab_select', {
          tabs_name: this.dataset.tabsName,
          tab_name: this.panels[i].dataset.tabName,
          tab_index: i + 1,
          method
        });
      }
    }
  }

  if (!customElements.get('tabs-content')) {
    customElements.define('tabs-content', TabsContent);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["timeline"] && !Shopify.designMode) return;
  try {
    
(function () {
  var REDUCED = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var REF = 0.6;

  function init(root) {
    if (!root || root.dataset.tlInit) return;
    root.dataset.tlInit = '1';

    var body = root.querySelector('.timeline__body');
    var items = root.querySelectorAll('.timeline__item');
    if (!body) return;

    if (REDUCED) {
      body.style.setProperty('--timeline-progress', '1');
      items.forEach(function (i) { i.classList.add('is-active'); });
      return;
    }

    root.classList.add('is-js');

    var reveal = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        e.target.classList.toggle('is-active', e.isIntersecting);
      });
    }, { rootMargin: '0px 0px -40% 0px', threshold: 0 });
    items.forEach(function (i) { reveal.observe(i); });

    var ticking = false, visible = false;
    function update() {
      ticking = false;
      var rect = body.getBoundingClientRect();
      var p = (window.innerHeight * REF - rect.top) / rect.height;
      p = Math.max(0, Math.min(1, p));
      body.style.setProperty('--timeline-progress', p.toFixed(4));
    }
    function request() { if (!ticking) { ticking = true; requestAnimationFrame(update); } }

    var vis = new IntersectionObserver(function (entries) {
      visible = entries[0].isIntersecting;
      if (visible) request();
    }, { threshold: 0 });
    vis.observe(root);

    window.addEventListener('scroll', function () { if (visible) request(); }, { passive: true });
    window.addEventListener('resize', function () { if (visible) request(); }, { passive: true });
    update();
  }

  function initAll() { document.querySelectorAll('.timeline').forEach(init); }
  if (document.readyState !== 'loading') initAll();
  else document.addEventListener('DOMContentLoaded', initAll);
  document.addEventListener('shopify:section:load', function (e) {
    var el = e.target.querySelector('.timeline');
    if (el) init(el);
  });
})();

  } catch(e) { console.error(e); }
})();
})();
